export default __webpack_public_path__ + "static/media/iacc.90649100.png";